<template>
    <span :class="getClass()">
        {{getLabel()}}
    </span>
</template>
<style>

</style>

<script>
    export default {
        props: {
            status: {
                type: Number,
                required: true
            }
        },
        methods: {
            getClass() {
                const self = this;
                switch (self.status) {
                    case 1:
                        return 'badge badge-warning';
                    case 2:
                        return 'badge badge-success';
                    case 3:
                        return 'badge badge-danger';
                    case 4:
                        return 'badge badge-primary';
                    case 5:
                        return 'badge badge-warning';
                    case 6:
                        return 'badge badge-info';
                    case 7:
                        return 'badge';
                    default:
                        return 'badge';
                }
            },
            getLabel() {
                const self = this;
                switch (self.status) {
                    case 1:
                        return 'PENDIENTE';
                    case 2:
                        return 'ASIGNADO';
                    case 3:
                        return 'CANCELADO';
                    case 4:
                        return 'HACIA PUNTO DE RECOJO';
                    case 5:
                        return 'EN PUNTO DE RECOJO';
                    case 6:
                        return 'INICIADO';
                    case 7:
                        return 'FINALIZADO';
                    default:
                        return 'PENDIENTE';
                }
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/ride/RideStatusBadges.vue